import { DownloadModal } from '@/features/download/components/downloadModal';
import type { ResponsiveDialogProps } from '@/shared/components/ui/custom/responsive-dialog';

export type DownloadAppPlayNowModalProps = ResponsiveDialogProps;

export function DownloadAppPlayNowModal(props: DownloadAppPlayNowModalProps) {
  const { open, ...rest } = props;

  return (
    <DownloadModal.Root open={open} {...rest}>
      <DownloadModal.Content>
        <DownloadModal.Header>
          <DownloadModal.Title>
            Get the app to keep using Play Now
          </DownloadModal.Title>
          <DownloadModal.Description>
            Play Now works with instant alerts so no one waits.
            <br />
            Download the app so you don't miss your next duo or leave someone
            waiting.
          </DownloadModal.Description>
        </DownloadModal.Header>
        <DownloadModal.Instructions />
        <DownloadModal.QrCode />
        <DownloadModal.StoreBadges />
      </DownloadModal.Content>
    </DownloadModal.Root>
  );
}
